import PropTypes from 'prop-types';
import classnames from 'classnames';
import {DeckGlMap} from '@gisatcz/ptr-maps';
import InterferometryMap from './maps/InterferometryMap';
import ZonesMap from './maps/ZonesMap';
import MapWrapper from './MapWrapper';
import MapTooltip from '../common/maps/MapTooltip/';
import ZoomControls from '../common/maps/ZoomControls';

import MapComponentsGroup from '../common/maps/MapComponentsGroup';
import Scale from '../common/maps/Scale';
import MapAttribution from '../common/maps/MapAttribution';

import './style.scss';

const Tooltip = props => {
	return <MapTooltip {...props}></MapTooltip>;
};

const MainMap = ({activeMapKey, chartExpanded, fullWidth, zonesMapKey}) => {
	const classes = classnames('insar-MainMap', {
		'full-width': fullWidth,
		'is-chartExpanded': chartExpanded,
	});

	return (
		<div className="insar-MainMapPanel">
			<div className={classes}>
				{activeMapKey === zonesMapKey ? (
					<ZonesMap
						mapComponent={DeckGlMap}
						stateMapKey={activeMapKey}
						wrapper={MapWrapper}
						Tooltip={Tooltip}
					>
						<MapComponentsGroup
							className="insar-MapInfoElements"
							key={'MapComponentsGroup_1'}
						>
							<MapComponentsGroup
								className="insar-AttributionScaleContainer"
								key={'MapComponentsGroup_11'}
							>
								<Scale key={'Scale'} />
								<MapAttribution mapKey={activeMapKey} key={'MapAttribution'} />
							</MapComponentsGroup>
						</MapComponentsGroup>
						<MapComponentsGroup
							className="insar-MapSetControls ptr-light"
							key={'MapComponentsGroup_2'}
						>
							<ZoomControls key={'ZoomControls'} />
						</MapComponentsGroup>
					</ZonesMap>
				) : (
					<InterferometryMap
						mapComponent={DeckGlMap}
						stateMapKey={activeMapKey}
						wrapper={MapWrapper}
						Tooltip={Tooltip}
					>
						<MapComponentsGroup
							className="insar-MapInfoElements"
							key={'MapComponentsGroup_1'}
						>
							<MapComponentsGroup
								className="insar-AttributionScaleContainer"
								key={'MapComponentsGroup_11'}
							>
								<Scale key={'Scale'} />
								<MapAttribution mapKey={activeMapKey} key={'MapAttribution'} />
							</MapComponentsGroup>
						</MapComponentsGroup>
						<MapComponentsGroup
							className="insar-MapSetControls ptr-light"
							key={'MapComponentsGroup'}
						>
							<ZoomControls key={'ZoomControls'} />
						</MapComponentsGroup>
					</InterferometryMap>
				)}
			</div>
		</div>
	);
};

MainMap.propTypes = {
	activeMapKey: PropTypes.string,
	chartExpanded: PropTypes.bool,
	fullWidth: PropTypes.bool,
	zonesMapKey: PropTypes.string,
};

export default MainMap;
